"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlight = void 0;
const highlight_component_1 = require("./highlight/highlight.component");
Object.defineProperty(exports, "Highlight", { enumerable: true, get: function () { return highlight_component_1.Highlight; } });
